import { useMemo } from 'react';

import { useGetFeedbackTemplatesQuery } from '../../../../../graphql/queries/generated/getFeedbackTemplate';

const useFeedbackTemplate = () => {
  const [{ data, fetching }] = useGetFeedbackTemplatesQuery({
    variables: {
      first: -1,
    },
  });

  const feedbackTemplate = useMemo(
    () => data?.peerFeedbackTemplates?.edges?.map((feedback) => feedback.node),
    [data?.peerFeedbackTemplates?.edges],
  );

  return {
    feedbackTemplate,
    fetching,
  };
};

export default useFeedbackTemplate;
